import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';


import { Parametro } from '../../model';

import { API, ITENSPORPAGINA , CLIENT_ID} from '../../app.config';


@Injectable()
export class ParametroService{
  constructor(
    private http: HttpClient,
    private router: Router,
    private login: LoginService){}


    buscarPorParametro(param: string, pagina: Number): Observable<any>{
      const headers = new HttpHeaders().set('noloader', 't');

      if (param.length > 0){
        return this.http.get<any>( `${API}/api/parametro/list/${param.trim()}?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }else{
        return this.http.get<any>( `${API}/api/parametro?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, {headers: headers});
      }
    }

    buscarPorId(id: number): Observable<any>{
        return this.http.get<any>( `${API}/api/parametro/${id}?Pagina=1&ItensPorPagina=${ITENSPORPAGINA}`);
    }

    remover(id: Number): Observable<any>{
      return this.http.delete<any>( `${API}/api/parametro/${id}`);
    }

    salvar(parametro: Parametro): Observable<any>{
      if (parametro.Id > 0){
        return this.http.put<any>( `${API}/api/parametro/${parametro.Id}`, parametro);
      }else{
        return this.http.post<any>( `${API}/api/parametro/`, parametro);
      }

    }

    BuscarParametroPorChave(chave: string, padrao: string = null): Observable<any> {
      return this.http.get<any>(`${API}/api/parametro/chave/${chave}/${padrao}`);
    }


  }
